import fetch from '../utils/fetch'

// 基础物料
export function getServiceLabelsList (query) {
  return fetch({
    url: '/goods/servicelabels',
    method: 'get',
    params: query
  })
}

export function getServiceLabelsDetail (labelId) {
  return fetch({
    url: '/goods/servicelabels/' + labelId,
    method: 'get'
  })
}

export function createServiceLabels (query) {
  return fetch({
    url: '/goods/servicelabels',
    method: 'post',
    data: query
  })
}

export function updateServiceLabels (labelId, query) {
  return fetch({
    url: '/goods/servicelabels/' + labelId,
    method: 'put',
    data: query
  })
}

export function deleteServiceLabels (labelId) {
  return fetch({
    url: '/goods/servicelabels/' + labelId,
    method: 'delete',
  })
}

// 商品类型
export function getItemsTypeList (query) {
  return fetch({
    url: '/goods/itemstype',
    method: 'get',
    params: query
  })
}

export function getItemsTypeDetail (typeId) {
  return fetch({
    url: '/goods/itemstype/' + typeId,
    method: 'get'
  })
}

export function getItemsTypeLabelsDetail (typeId) {
  return fetch({
    url: '/goods/itemstypelabels/' + typeId,
    method: 'get'
  })
}

export function createItemsType (query) {
  return fetch({
    url: '/goods/itemstype',
    method: 'post',
    data: query
  })
}

export function updateItemsType (typeId, query) {
  return fetch({
    url: '/goods/itemstype/' + typeId,
    method: 'put',
    data: query
  })
}

export function deleteItemsType (typeId) {
  return fetch({
    url: '/goods/itemstype/' + typeId,
    method: 'delete',
  })
}

// 商品
export function getItemsList (query) {
  return fetch({
    url: '/goods/items',
    method: 'get',
    params: query
  })
}
// 店铺商品
export function getDistributorItemsList (query) {
  return fetch({
    url: '/distributor/items',
    method: 'get',
    params: query
  })
}

// vip商品列
export function getVipItemsList (query) {
  return fetch({
    url: '/goods/vip/itemslist',
    method: 'get',
    params: query
  })
}
// 批量修改商品vip会员价
export function changVipItemsPrice (query) {
    return fetch({
        url:'/goods/vip/itemsprice/sync',
        method:'post',
        data:query
    })
}
// 修改某个存在vip商品列表的会员价
export function updateOneVipItems (query) {
    return fetch({
        url:'/goods/vip/update/one/price',
        method:'post',
        data:query
    })
}

export function getItemsDetail (itemId) {
  return fetch({
    url: '/goods/items/' + itemId,
    method: 'get'
  })
}
// 店铺分类商品
export function getDistributorCategoryItemsList (query) {
  return fetch({
    url: '/distributor/category/items',
    method: 'get',
    params: query
  })
}
export function createItems (query) {
  return fetch({
    url: '/goods/items',
    method: 'post',
    data: query,
    refreshToken: true
  })
}

export function updateItems (itemId, query) {
  return fetch({
    url: '/goods/items/' + itemId,
    method: 'put',
    data: query,
    refreshToken: true
  })
}

export function setItemsTemplate (params) {
  return fetch({
    url: '/goods/setItemsTemplate',
    method: 'post',
    data: params
  })
}

export function setItemsSort (params) {
  return fetch({
    url: '/goods/setItemsSort',
    method: 'post',
    data: params
  })
}

export function setItemsCategory (params) {
  return fetch({
    url: '/goods/setItemsCategory',
    method: 'post',
    data: params
  })
}

export function deleteItems (itemId) {
  return fetch({
    url: '/goods/items/' + itemId,
    method: 'delete',
  })
}

export function getDistributionGoodsWxaCode (query) {
  return fetch({
    url: '/goods/distributionGoodsWxaCodeStream',
    method: 'get',
    params: query
  })
}

export function getItemWarningStore(query) {
  return fetch({
    url: '/goods/warning_store',
    method: 'post',
    data: query
  })
}

export function getCategory(query) {
  return fetch({
    url: '/goods/category',
    method: 'get',
    params: query
  })
}

export function saveCategory(params) {
  return fetch({
    url: '/goods/category',
    method: 'post',
    data: params
  })
}

export function deleteCategory(category_id) {
  return fetch({
    url: '/goods/category/' + category_id,
    method: 'delete'
  })
}

export function updateCategory(category_id, query) {
  return fetch({
    url: '/goods/category/' + category_id,
    method: 'put',
    data: query
  })
}

export function getCategoryInfo(category_id) {
  return fetch({
    url: '/goods/category/' + category_id,
    method: 'get'
  })
}

export function getGoodsAttr(query) {
  return fetch({
    url: '/goods/attributes',
    method: 'get',
    params: query
  })
}

export function addGoodsAttr(query) {
  return fetch({
    url: '/goods/attributes',
    method: 'post',
    data: query
  })
}

export function updateGoodsAttr(attributes_id, query) {
  return fetch({
    url: '/goods/attributes/' + attributes_id,
    method: 'put',
    data: query
  })
}

export function deleteGoodsAttr(attributes_id) {
  return fetch({
    url: '/goods/attributes/' + attributes_id,
    method: 'delete'
  })
}

export function updateGoodsInfo(query) {
  return fetch({
    url: '/goods/itemsupdate',
    method: 'put',
    data: query
  })
}

export function getGoodsPrice(id) {
  return fetch({
    url: '/goods/memberprice/' + id,
    method: 'get'
  })
}

export function updateGoodsPrice(query) {
  return fetch({
    url: '/goods/memberprice/save',
    method: 'post',
    data: query
  })
}

//价格同步到店铺
export function syncBatchPrice(query) {
    return fetch({
        url: '/goods/batch/price/sync',
        method: 'put',
        data: query
    })
}

export function updateItemRebateConf(query) {
  return fetch({
    url: '/goods/rebateconf',
    method: 'post',
    data: query
  })
}

export function saveTag (query) {
  return fetch({
    url: '/goods/tag',
    method: 'post',
    data: query
  })
}

export function getTagList (query) {
  return fetch({
    url: '/goods/tag',
    method: 'get',
    params: query
  })
}

export function getTagInfo (tagId) {
  return fetch({
    url: '/goods/tag/' + tagId,
    method: 'get'
  })
}

export function updateTag (query) {
  return fetch({
    url: '/goods/tag',
    method: 'put',
    data: query
  })
}

export function deleteTag (tagId) {
  return fetch({
    url: '/goods/tag/' + tagId,
    method: 'delete'
  })
}

export function itemsRelTags (query) {
  return fetch({
    url: '/goods/reltag/',
    method: 'post',
    data: query
  })
}

export function tagSearchItem (query) {
  return fetch({
    url: '/goods/tagsearch',
    method: 'GET',
    params: query
  })
}

export function setHotKeywords(query) {
  return fetch({
    url: '/goods/hotkeywords',
    method: 'post',
    data: query
  })
}

export function getHotKeywords () {
  return fetch({
    url: '/goods/hotkeywords',
    method: 'get'
  })
}

export function updateItemsStore (query) {
  return fetch({
    url: '/goods/itemstoreupdate',
    method: 'put',
    data: query
  })
}

export function updateItemsStatus (query) {
  return fetch({
    url: '/goods/itemstatusupdate',
    method: 'put',
    data: query
  })
}

export function updateItemsStockSyncStatus (query) {
  return fetch({
    url: 'goods/itemstocksyncstatusupdate',
    method: 'put',
    data: query
  })
}

export function auditItems (query) {
  return fetch({
    url: '/goods/audit/items',
    method: 'put',
    data: query
  })
}
export function savebatchGoodsPricesApi (query) {
  return fetch({
    url: '/goods/batchgoodsprices',
    method: 'post',
    data: query
  })
}

export function getDownloadList (query) {
  return fetch({
    url: '/goods/download',
    method: 'get',
    params: query
  })
}

export function getItemsFlagSetting (query) {
  return fetch({
    url: '/setting/itemsflag',
    method: 'get',
    params: query
  })
}

export function setItemsFlagSetting (query) {
  return fetch({
    url: '/setting/itemsflag',
    method: 'put',
    params: query
  })
}

export function delItemsCache (params) {
  return fetch({
    url: '/goods/clearCache',
    method: 'post',
    data: params
  })
}

export function saveToDistributor(params) {
  return fetch({
    url: '/goods/category/savetodistributor',
    method: 'post',
    data: params
  })
}
export function deltags(params) {
  return fetch({
    url: '/goods/deltags',
    method: 'post',
    data: params
  })
}
// 2021-11-11 新增组合商品方法

export function getPackagePromotions(query) {
  return fetch({
    url: '/goods/promotions/package',
    method: 'get',
    params: query
  })
}

export function getPackagePromotionsInfo(id) {
  return fetch({
    url: '/goods/promotions/package/' + id,
    method: 'get'
  })
}

export function createPackagePromotions(params) {
  return fetch({
    url: '/goods/promotions/package',
    method: 'post',
    data: params
  })
}

export function updatePackagePromotions(id, params) {
  return fetch({
    url: '/goods/promotions/package/' + id,
    method: 'put',
    data: params
  })
}

export function cancelPackagePromotions(id) {
  return fetch({
    url: '/goods/promotions/package/cancel/' + id,
    method: 'delete'
  })
}

export function correctionStore (params) {
  return fetch({
    url: '/goods/correction/store',
    method: 'post',
    data: params
  })
}

export function getItemQRcode (params) {
  return fetch({
    url: '/goods/getQRcode',
    method: 'post',
    data: params
  })
}

export function getItemsAttrList (query) {
  return fetch({
    url: '/goods/itemsattr/list',
    method: 'get'
  })
}

export function getItemsScopeList (query) {
  return fetch({
    url: '/goods/itemsscope/list',
    method: 'get'
  })
}

export function setVipItmesPrice (params) {
  return fetch({
    url: '/goods/set/vipItem/price',
    method: 'post',
    data: params
  })
}

export function goodsBatchShelfUpToDown(params) {
    return fetch({
        url: '/goods/batchShelfUpToDown',
        method: 'post',
        data: params
    })
}

export function goodsBatchShelfDownToUp(params) {
    return fetch({
        url: '/goods/batchShelfDownToUp',
        method: 'post',
        data: params
    })
}


export function getPriceReviewList(params) {
  return fetch({
      url: '/goods/prices/review/list',
      method: 'post',
      data: params
  })
}

export function reviewPriceDo(params) {
  return fetch({
    url: '/goods/prices/review/do',
    method: 'post',
    data: params
  })
}

export function saverReviewPriceTitle(params) {
  return fetch({
    url: '/goods/prices/reviewtitleUp',
    method: 'post',
    data: params
  })
}

export function reviewPriceDoList(params) {
  return fetch({
    url: '/goods/prices/review/dolist',
    method: 'post',
    data: params
  })
}

export function reviewUpload(params) {
  return fetch({
    url:'/goods/prices/review/upload',
    method:'post',
    data:params
  })
}

export function getPriceReviewTitleList(params) {
  return fetch({
      url: '/goods/prices/reviewtitlelist',
      method: 'post',
      data: params
  })
}

// 批量设置商品区域划线价
export function setItemAreaMarketPrice (params) {
  return fetch({
    url: '/goods/setItemAreaMarketPrice',
    method: 'post',
    data: params
  })
}

// 查询指定商品区域划线价
export function getItemAreaMarketPrice (query) {
  return fetch({
    url: '/goods/getItemAreaMarketPrice',
    method: 'get',
    params: query
  })
}

// 查询SKU信息
export function getItemSkuInfo (query) {
  return fetch({
    url: '/goods/getItemSkuInfo',
    method: 'get',
    params: query
  })
}

// 商品买赠活动数据预览
export function preBuyonesfreeones (query) {
  return fetch({
    url: '/items/buyonesfreeones/preview',
    method: 'get',
    params: query
  })
}

// 商品买赠活动数据导出
export function buyonesfreeonesExport (query) {
  return fetch({
    url: '/items/buyonesfreeones/export',
    method: 'get',
    params: query
  })
}

// 商品限时特惠活动数据预览
export function preLimitedtimesale (query) {
  return fetch({
    url: '/items/limitedtimesale/preview',
    method: 'get',
    params: query
  })
}

// 商品限时特惠活动数据导出
export function limitedtimesaleExport (query) {
  return fetch({
    url: '/items/limitedtimesale/export',
    method: 'get',
    params: query
  })
}

// 获取售商品列表
export function getDisabledItemsList (query) {
  return fetch({
    url: '/goods/disableditems',
    method: 'get',
    params: query
  })
}

// 添加禁售商品
export function addDisabledItems (params) {
  return fetch({
    url: '/goods/disableditems',
    method: 'post',
    data: params
  })
}

// 删除禁售商品
export function delDisabledItems (id) {
  return fetch({
    url: '/goods/disableditems/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/goods.js